import { render, staticRenderFns } from "./ProductSalesPageIncludedLessons.vue?vue&type=template&id=51c5d074&scoped=true&"
import script from "./ProductSalesPageIncludedLessons.vue?vue&type=script&lang=ts&"
export * from "./ProductSalesPageIncludedLessons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c5d074",
  null
  
)

export default component.exports